import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/configs/app.config';

@Component({
  selector: 'app-typing-three-dot-loader',
  templateUrl: './typing-three-dot-loader.component.html',
  styleUrls: ['./typing-three-dot-loader.component.scss']
})
export class TypingThreeDotLoaderComponent implements OnInit {

  readonly imgPath: string;

  constructor() {
    this.imgPath = AppConfig.POPUP_LOGO;
  }

  ngOnInit(): void {
  }

}
